/**
 * Parses the url equals condition
 *
 * @param {Boolean} equalsOption - determines to check for a positive or negative condition (e.g. "url equals" or "does not equal")
 * @param {Object} condition - contains the conditions to check for
 *
 * @return {Boolean}
 */
const parseEqualsConditions = (equalsOption, condition) => {
  const { selector } = condition;
  let userAgentFromBrowser = navigator.userAgent;

  try {
    if (
      userAgentFromBrowser != undefined &&
      userAgentFromBrowser.includes(selector)
    ) {
      return false;
    }
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

/**
 * We have only condition in the initial code. This framework allows to add more conditions
 * Runs the user agent display engine, passes off work to smaller functions
 *
 * @param {Object} condition - object containing conditions
 *
 * @return {Boolean}
 */
export default (condition) => {
  const { options } = condition;

  switch (options) {
    case "does not equal":
      return parseEqualsConditions(false, condition);
  }
};
